import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getCountry } from '../../../Utils/ForeignUtils';
import { pushSameRouteMaternity } from '../../../Utils/PaymentUtils/utils';
import { removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { harcodedTextFlagData } from '../../CategoryDetail/CategoryProductTags/constant';
import { getSearchParams } from '../../Parenting/common';
import AddToCartCta from '../../StoreCategoryPage/SubCategoryProducts/AddToCartCta';
import MaternityCardCTA from '../SelectSizeButton';
import { ButtonPriceContainer } from '../SelectSizeButton/styled';
import { clickedCardEvent, clickedCtaEvent } from '../instrumentation';
import { SelectSizeText } from '../utils';
import {
  Discount,
  LightningPrice,
  Price,
  ProductCards,
  ProductDetail,
  ProductImage,
  ProductName,
  ProductPriceStrip,
  ProductStyle,
  StrikePrice,
} from './styled';

export default function MaternityProductCards(props) {
  const {
    item,
    setShowSizePopup,
    setProductId,
    sectionId,
    setEventsData,
    userType,
    index,
    type,
    setAddedToCart,
    categoryName,
    statusOfIds,
    outerIndex,
  } = props;
  const [focusElement, setFocusElement] = useState(null);
  const [showLoader, setShowLoader] = useState(false);

  const section = {
    _id: sectionId,
    heading: type,
  };
  const country = getCountry();
  const router = useRouter();
  const sku_url = item?.webUrl;
  const ctaClickHandler = (event, productId, item) => {
    setShowLoader(true);
    event.preventDefault();
    event.stopPropagation();
    const page_url = window.location.pathname;
    setProductId(productId);
    clickedCtaEvent(
      item.name.substring(0, 99),
      productId,
      page_url.substring(0, 99),
      SelectSizeText(),
    );
    setTimeout(() => {
      if (item?.sizeVariants?.length) {
        setShowSizePopup(true);
        pushSameRouteMaternity(router, 'sizepopup');
        document.getElementsByTagName('body')[0].classList.add('noScroll');
        setShowLoader(false);
      } else {
        setAddedToCart(true);
      }
    }, 0);
    setEventsData({
      sectionName: type,
      sectionId: sectionId,
      productName: item.nickname,
      productNickname: item.nickname,
      sellingPrice: item.price,
    });
  };
  const productClickHandler = (event, item) => {
    event.preventDefault();
    const pid = Number(event.target.getAttribute('data-productid'));
    if (pid) {
      ctaClickHandler(event, pid, item);
    } else {
      setFocusElement('lowOpacity');

      const skuId = item._id;
      const skuName = item.name.substring(0, 99);
      const sectionName = type;
      const url = window.location.pathname;
      clickedCardEvent(
        sectionName,
        sectionId,
        skuName,
        skuId,
        url.substring(0, 99),
      );

      setTimeout(() => {
        router.push(sku_url + getSearchParams(), '', {
          locale: getRouterLocale(router),
        });
        setFocusElement(null);
      }, 200);
    }
  };
  // const calculateDiscount = (price, strikeprice) => {
  //     return Math.ceil(((strikeprice - price) / strikeprice) * 100);
  // };
  const productFlagData = item?.textFlag || harcodedTextFlagData;

  return (
    <Link
      href={{
        pathname: sku_url,
        query: removeDefaultParams(router.query),
      }}
      locale={false}
      passHref
      legacyBehavior
    >
      <ProductCards
        as="a"
        onClick={(event) => productClickHandler(event, item)}
        className={focusElement}
        userType={userType}
      >
        <ProductImage imgFit={'cover'} userType={userType}>
          {/* {productFlagData?.text?.length > 0 && (
                        <ProductFlag flagData={productFlagData}>
                            {productFlagData?.text}
                            <span></span>
                        </ProductFlag>
                    )} */}
          <Image
            src={item.image}
            priority={index < 3 && outerIndex === 0 ? true : false}
            quality={100}
            alt=""
            loading={index < 3 && outerIndex === 0 ? 'eager' : 'lazy'}
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88+F3PQAI/wNYdVMfwAAAAABJRU5ErkJggg"
            fill
            sizes="40vw"
          ></Image>
        </ProductImage>
        <ProductDetail>
          <ProductName>{item?.variantType}</ProductName>
          <ProductStyle>{type?.toLowerCase()}</ProductStyle>
          <ButtonPriceContainer>
            <ProductPriceStrip>
              <Price>{item?.actual_web_price || item?.price}</Price>
              {item?.discount && (
                <>
                  <StrikePrice>{item?.strikePrice}</StrikePrice>
                  <Discount>{item?.discount}</Discount>
                </>
              )}
            </ProductPriceStrip>
            {item?.actual_web_price && (
              <LightningPrice>
                <img src={images.lightning} alt="" />
                <p>Deal Price {item?.price}</p>
              </LightningPrice>
            )}
            {item?.sizeVariants?.length ? (
              <MaternityCardCTA product={item._id} showLoader={showLoader} />
            ) : (
              <AddToCartCta
                product={item}
                section={section}
                category_name={categoryName}
                setAddedToCart={setAddedToCart}
                smallButton={true}
                isCategoryPage={true}
                statusOfIds={statusOfIds}
              />
            )}
          </ButtonPriceContainer>
        </ProductDetail>
      </ProductCards>
    </Link>
  );
}
